import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Sidebar1 from "./Sidebar1";
import Footer from "./Footer";
const Layout = () => {
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <Sidebar />
        <div className="layout-page">
          <Navbar />
          {/* Content wrapper */}
          <div className="content-wrapper">
            {/* Content */}
            <div className="container-fluid flex-grow-1 container-p-y">
              <Outlet />
             
            </div>
          
          </div>
          <Footer />
        </div>
        
      </div>
    </div>
  );
};

export default Layout;
